import { AppContext } from "@/App.context";
import config from "@/config";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import {
  ERROR_STATUS_CODES,
  API_LOADING_ERROR_CUSTOM_WIDGET,
  API_NOT_FOUND_ERROR_CUSTOM_WIDGET,
  API_NO_DATA_FOUND_ERROR_CUSTOM_WIDGET,
} from "@/lib/errors/error-constants";

export const getCostStats = (token) => {
  return async ({ service }) => {
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/cost-anomaly/costStats`,
      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      if (ERROR_STATUS_CODES.includes(owners.status)) {
        throw new Error(API_LOADING_ERROR_CUSTOM_WIDGET);
      }
      if (owners.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR_CUSTOM_WIDGET);
      }
      throw new Error((await owners.json()).message);
    }
    const data = await owners.json();

    if (
      (!data?.totalAnomalyCost || data?.totalAnomalyCost === 0) &&
      (!data?.totalCost || data?.totalCost === 0)
    ) {
      throw new Error(API_NO_DATA_FOUND_ERROR_CUSTOM_WIDGET);
    }

    return data;
  };
};

export const getMaxStats = (token) => {
  return async ({ service }) => {
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/cost-anomaly/maxStats`,
      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      if (ERROR_STATUS_CODES.includes(owners.status)) {
        throw new Error(API_LOADING_ERROR_CUSTOM_WIDGET);
      }
      if (owners.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR_CUSTOM_WIDGET);
      }
      throw new Error((await owners.json()).message);
    }
    const data = await owners.json();

    if (!data?.maxCost || data?.maxCost === 0) {
      throw new Error(API_NO_DATA_FOUND_ERROR_CUSTOM_WIDGET);
    }

    return data;
  };
};

export const getCountStats = (token) => {
  return async ({ service }) => {
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/cost-anomaly/countStats`,
      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      if (ERROR_STATUS_CODES.includes(owners.status)) {
        throw new Error(API_LOADING_ERROR_CUSTOM_WIDGET);
      }
      if (owners.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR_CUSTOM_WIDGET);
      }
      throw new Error((await owners.json()).message);
    }
    const data = await owners.json();

    if (
      (!data?.awsPercentage || data?.awsPercentage === 0) &&
      (!data?.total || data?.total === 0) &&
      (!data?.azurePercentage || data?.azurePercentage === 0) &&
      (!data?.gcpPercentage || data?.gcpPercentage === 0)
    ) {
      throw new Error(API_NO_DATA_FOUND_ERROR_CUSTOM_WIDGET);
    }

    return data;
  };
};

/**

 * @param {GetStatisticsReq} req
 * @param {any[]=} deps
 */
export const useCostStats = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getCostStats", req, ...deps],
    queryFn: () => getCostStats(appContext.idToken)(req),
  });
  return query;
};
export const useMaxStats = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getMaxStats", req, ...deps],
    queryFn: () => getMaxStats(appContext.idToken)(req),
  });
  return query;
};
export const useCountStats = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getCountStats", req, ...deps],
    queryFn: () => getCountStats(appContext.idToken)(req),
  });
  return query;
};
